export default __webpack_public_path__ + "static/media/Scarhide Bracers.2804acf8.jpg";